export function shortName(name: string | null | undefined) {
  if (!name) {
    return "";
  }

  return name.trim().split(/\s+/)[0] ?? "";
}

export function truncate(
  str: string | null | undefined,
  length: number,
  suffix = "...",
): string {
  if (!str) {
    return "";
  }

  if (str.length <= length) {
    return str;
  }

  return str.slice(0, length) + suffix;
}

export function truncateWord(
  str: string | null | undefined,
  length: number,
  suffix = "...",
): string {
  if (!str) {
    return "";
  }

  if (str.length <= length) {
    return str;
  }

  const words = [];
  let currentLength = 0;

  for (const word of str.split(" ")) {
    if (currentLength + word.length > length) {
      break;
    }
    words.push(word);
    currentLength += word.length + 1; // +1 for the space
  }

  return words.join(" ") + suffix;
}

export function isEmailDeleted(email: string) {
  return email.startsWith("deleteduser+") && email.endsWith("@venturu.com");
}

export function prettyNumber(
  value: number | bigint,
  useNumber = false,
): string {
  const numB = 1_000_000_000;
  const numM = 1_000_000;
  const numK = 1_000;

  const bigB = BigInt(numB);
  const bigM = BigInt(numM);
  const bigK = BigInt(numK);

  let output: string;

  if (useNumber) {
    if (value >= numB) {
      output = `${(Number(value) / numB).toFixed(1)}B`;
    } else if (value >= numM) {
      output = `${(Number(value) / numM).toFixed(1)}M`;
    } else if (value >= numK) {
      output = `${(Number(value) / numK).toFixed(1)}K`;
    } else {
      output = value.toString();
    }

    return output.replace(".0", "");
  }

  if (value >= bigB) {
    output = `${Number(BigInt(value) / bigB).toFixed(1)}B`;
  } else if (value >= bigM) {
    output = `${Number(BigInt(value) / bigM).toFixed(1)}M`;
  } else if (value >= bigK) {
    output = `${Number(BigInt(value) / bigK).toFixed(1)}K`;
  } else {
    output = value.toString();
  }

  return output.replace(".0", "");
}
